var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  ref: "bitacoraEstadosModal",
                  attrs: {
                    "header-bg-variant": "primary",
                    size: "xl",
                    title: "Bitacora solicitudes",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mr-3",
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.ocultarModalBitacoraEstados()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "icon-cerrar",
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.bitacoraEstadosSolicitudes.btn.cerrar"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c("b-table", {
                              staticClass: "text-nowrap mt-3",
                              attrs: {
                                responsive: "",
                                "sticky-header": "70vh",
                                "show-empty": "",
                                "head-variant": "primary",
                                fields: _vm.campos,
                                items: _vm.eventos,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "cell(descripcion)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "descripcion",
                                          staticStyle: {
                                            width: "24rem",
                                            height: "2rem",
                                          },
                                        },
                                        [_vm._v(_vm._s(data.value))]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(nombreCompleto)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "descripcion",
                                          staticStyle: {
                                            width: "24rem",
                                            height: "2rem",
                                          },
                                        },
                                        [_vm._v(_vm._s(data.value))]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "empty",
                                  fn: function () {
                                    return [
                                      _c(
                                        "b-row",
                                        { attrs: { "align-h": "center" } },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "4" } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.bitacoraEstadosSolicitudes.mensaje.sinEventos"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }